// extracted by mini-css-extract-plugin
export var container = "_bs-1";
export var cornerButtonContainer = "_bs-5";
export var disabled = "_bs-2";
export var fileContainer = "_bs-4";
export var hiddenInput = "_bs-3";
export var widthContainer = "_bs-0";